import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';
import type { ComponentSlotStyleFunction } from '@fluentui/styles';

export const MOBILE_INPUT_BG = '#EEE';
export const INPUT_ERROR_COLOR = '#E5505C';

export const ModalHeader: ComponentSlotStyleFunction = () => ({
    margin: pxArrayToRem([28, 18]),
});

export const ModalHeaderAction: ComponentSlotStyleFunction = ({ theme }) => ({
    background: theme.siteVariables.colors.white['100A'],
});

export const ModalClose: StyleRule = () => ({
    margin: pxArrayToRem([2, 14, 0]),
    width: `${pxToRem(24)} !important`,
    height: `${pxToRem(24)} !important`,
});

export const ModalContent: StyleRule = () => ({
    borderTop: 0,
    padding: pxArrayToRem([6, 18]),
});

export const ModalFormFields: StyleRule = () => ({
    minHeight: pxToRem(302),
});

export const ModalFormField: StyleRule<{
    canSubmit: boolean;
    validEmail: boolean;
}> = ({ canSubmit, validEmail }) => ({
    position: 'relative',
    '& input': {
        display: validEmail && canSubmit ? 'none' : 'block',
    },
    '& > div': {
        marginBottom: validEmail && canSubmit ? pxToRem(37) : 0,
    },
    '&:focus-within': {
        '& input': {
            display: 'block',
        },
        '& > div': {
            marginBottom: 0,
        },
    },
});

export const InputError: StyleRule = () => ({
    position: 'absolute',
    bottom: pxToRem(2),
    right: pxToRem(8),
});

export const InputField: (textArea: boolean) => StyleRule =
    (textArea) =>
    ({ theme }) => {
        return {
            ...theme.siteVariables.textStyles.Text.Roman55,
            width: '100%',
            height: textArea ? pxToRem(174) : pxToRem(66),
            resize: 'none',
            border: 'none',
            padding: pxArrayToRem([25, 13]),
            marginBottom: pxToRem(10),
            backgroundColor: MOBILE_INPUT_BG,
            fontSize: `max(16px, ${theme.siteVariables.fontSizes.caption03})`,
            lineHeight: theme.siteVariables.lineHeightSmall,

            '&:focus': {
                outline: 'none',
            },

            '&::placeholder': {
                color: theme.siteVariables.colors.charcoal['250'],
                opacity: 0.4,
            },
        };
    };

export const ModalFormAction: StyleRule = () => ({
    width: '100%',
});

export const CollaboratorsTopDivider: StyleRule = ({ theme }) => ({
    marginBottom: theme.siteVariables.spaces['space-32'],
});

export const CollaboratorsCaption: StyleRule = ({ theme }) => ({
    letterSpacing: '0.01em !important',
    marginBottom: theme.siteVariables.spaces['space-24'],
});
export const Selector: StyleRule = ({ theme }) => ({
    margin: pxArrayToRem([3, 0]),
    width: pxToRem(10),
    '& svg': {
        width: pxToRem(10),
        height: pxToRem(10),
    },

    [theme.screen.tablet]: {
        marginRight: pxToRem(14),
    },
});

export const PermissionToggle: StyleRule = ({ theme }) => ({
    marginTop: theme.siteVariables.spaces['space-20'],
    marginBottom: theme.siteVariables.spaces['space-20'],
    cursor: 'pointer',

    [theme.screen.max.tablet]: {
        height: pxToRem(16),
    },
});

export const Description: StyleRule<{ shortDescription?: boolean }> = ({
    shortDescription,
}) => ({
    marginRight: pxToRem(8),
    '&::first-letter': {
        textTransform: shortDescription ? 'uppercase' : 'none',
    },
});
